import React from 'react';
import { AuthContext } from '../../authContext.js';
/**
 * Returns the authenticated user from {@link AuthContext}.
 *
 * `UserDto.company` corresponds to the company selected in the switcher,
 * or the user's own company if no company is selected.
 */
const useIdentityUser = () => {
    const { identity: { user }, } = React.useContext(AuthContext);
    return user;
};
export default useIdentityUser;
